import { useContext } from "react"
import { ToolContext } from "../../../../core/context/ToolContext"
import { Box, Button, Typography } from "@mui/material"
export const FormHeader = ({handleBackClick}) =>{
    const {reconciliation_state, session_state} = useContext(ToolContext)
    const {reconData} = reconciliation_state
    const {sessionData} = session_state

    return(
        <>
            <Box display="flex" justifyContent="space-between">
                <Button variant="text" onClick={handleBackClick}>← Back</Button>
                <Box p={1} textAlign="center" borderRadius={3} fontWeight={600} color="primary.main"> RECONCILE BRANCH SALES</Box>
            </Box>

            <Box p={2} bgcolor="#FFFFFF" boxShadow={2} borderRadius={2} mb={2}> 
                <Box display="flex" justifyContent="space-between">
                    <Typography fontSize={13}>Branch Sales ID:</Typography>
                    <Typography fontSize={13}>{reconData.data.id}</Typography>
                </Box>
                
                <Box display="flex" justifyContent="space-between">
                    <Typography fontSize={13}>Branch:</Typography>
                    <Typography fontSize={13}>{sessionData.data.branch_name}</Typography>
                </Box>

                <Box display="flex" justifyContent="space-between">
                    <Typography fontSize={13}>Date:</Typography>
                    <Typography fontSize={13}>{reconData.data.date}</Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                    <Typography fontSize={13}>Status:</Typography>
                    <Box px={2} py={0.5} borderRadius={2}bgcolor={reconData.data.status === 1 ? "warning.main" : reconData.data.status === 2 ? "warning.main" : reconData.data.status === 3 ? "info.main" : reconData.data.status === 4 ? "success.main" : "grey.300"} color="#FFFFFF" fontWeight={600} fontSize={12}>
                        <Typography fontSize={13}>{reconData.data.status === 1 ? "To Reconcile" : reconData.data.status === 2 ? "For Review" : reconData.data.status === 3 ? "For Approval" : "Approved"}</Typography>
                    </Box>
                </Box>
            </Box>
        </>
    )
}